export const COMPLETED_REGISTRATION_STATUS = 4